import React, { Component } from 'react'

import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';


import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import CardContent from '@material-ui/core/CardContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEdit, faTrash, faPlusSquare} from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { authMiddleWare } from '../util/auth';

import '../styles/styles.css' 



const styles = ((theme) => ({
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    toolbar: theme.mixins.toolbar,
    title: {
		marginLeft: theme.spacing(2),
		flex: 1
	},
	submitButton: {
		display: 'block',
		color: 'white',
		textAlign: 'center',
		position: 'absolute',
		top: 14,
		right: 10
	},
	floatingButton: {
		position: 'fixed',
		bottom: 0,
		right: 0
	},
	form: {
		width: '98%',
		marginLeft: 13,
		marginTop: theme.spacing(3)
	},
	toolbar: theme.mixins.toolbar,
	root: {
		minWidth: 470
	},
	bullet: {
		display: 'inline-block',
		margin: '0 2px',
		transform: 'scale(0.8)'
	},
	pos: {
		marginBottom: 12
	},
	uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	},
	dialogeStyle: {
		maxWidth: '50%'
	},
	viewRoot: {
		margin: 0,
		padding: theme.spacing(2)
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500]
	},
	
})
);
				
const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});				
				

class projects extends Component {
	constructor(props) {
		super(props);

		this.state = {
			todos: '',
			projects: [],
			title: '',
			body: '',
			todoId: '',
			errors: [],
			open: false,
			uiLoading: true,
			buttonType: '',
			viewOpen: false
		};

		this.deleteProjectHandler = this.deleteProjectHandler.bind(this);
		this.handleEditClickOpen = this.handleEditClickOpen.bind(this);
		this.handleViewOpen = this.handleViewOpen.bind(this);

	}

	handleChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		});
	};

	componentDidMount = () => {
		authMiddleWare(this.props.history);
		const authToken = localStorage.getItem('AuthToken');
	
		console.log("Was sind die props")
		console.log(this.props)

		
		axios.defaults.headers.common = { Authorization: `${authToken}` };
		axios
			.get('/projects')
			.then((response) => {
			//console.log("HUHUUU REULTAT", response.data);
			
			//var test =   this.getMarkerCounter(response.data[1].projectId)
			//console.log("UND NUN AUCH DER RESU"+test);

			
				this.setState({
					projects: response.data,
					uiLoading: false
				});
			
				
							/* response.data.forEach((project) => {
								 
								 	var test =   this.getMarkerCounter(project.projectId)

								})*/
			
			
			})
			.catch((err) => {
			console.log("KEINE RESULTATE");
				console.log(err);
								this.props.history.push('/login');

			});
		
		
		
		
		
	};

	deleteProjectHandler(data) {
		authMiddleWare(this.props.history);
		const authToken = localStorage.getItem('AuthToken');
		axios.defaults.headers.common = { Authorization: `${authToken}` };
		let projectId = data.project.projectId;
		axios
			.delete(`projects/${projectId}`)
			.then(() => {
				window.location.reload();
			})
			.catch((err) => {
				console.log(err);
			});
	}

	handleEditClickOpen(data) {
		this.setState({
			title: data.todo.title,
			body: data.todo.body,
			todoId: data.todo.todoId,
			buttonType: 'Edit',
			open: true
		});
	}

	handleViewOpen(data) {
		this.setState({
			title: data.todo.title,
			body: data.todo.body,
			viewOpen: true
		});
	}


 async getMarkerCounter (projectId)  {
			
		
			var markerCount = 1
					const authToken = localStorage.getItem('AuthToken');
						axios.defaults.headers.common = { Authorization: `${authToken}` };
						
			try {
				
								console.log("Die ANFRAGE"+projectId)

				
				const resp = await  axios.get(`/marker/${projectId}`)
					
				console.log("DER MARKER RET")
				console.log(resp)
				
				
				var objIndex = this.state.projects.findIndex((obj => obj.projectId == projectId));	

				var helperArray = this.state.projects
				helperArray[objIndex].markerCount = resp.data.length
				this.setState({
					projects: helperArray,

				});
				
				
				
				return await resp.json();
				}
		
			catch{
				return "-"
			}
	
}

	

	render() {
		const DialogTitle = withStyles(styles)((props) => {
			const { children, classes, onClose, ...other } = props;
			return (
				<MuiDialogTitle disableTypography className={classes.root} {...other}>
					<Typography variant="h6">{children}</Typography>
					{onClose ? (
						<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
							<CloseIcon />
						</IconButton>
					) : null}
				</MuiDialogTitle>
			);
		});

		const DialogContent = withStyles((theme) => ({
			viewRoot: {
				padding: theme.spacing(2)
			}
		}))(MuiDialogContent);

		dayjs.extend(relativeTime);
		const { classes } = this.props;
		const { open, errors, viewOpen } = this.state;

		const handleClickOpen = () => {
			
			
			
			
			this.setState({
				todoId: '',
				title: '',
				body: '',
				buttonType: '',
				open: true
			});
		
		
		
		};

		const handleSubmit = (event) => {
			authMiddleWare(this.props.history);
			event.preventDefault();
			const userTodo = {
				title: this.state.title,
				body: this.state.body
			};
			let options = {};
			if (this.state.buttonType === 'Edit') {
				options = {
					url: `/todo/${this.state.todoId}`,
					method: 'put',
					data: userTodo
				};
			} else {
				options = {
					url: '/todo',
					method: 'post',
					data: userTodo
				};
			}
			const authToken = localStorage.getItem('AuthToken');
			axios.defaults.headers.common = { Authorization: `${authToken}` };
			axios(options)
				.then(() => {
					this.setState({ open: false });
					window.location.reload();
				})
				.catch((error) => {
					this.setState({ open: true, errors: error.response.data });
					console.log(error);
				});
		};

		const handleViewClose = () => {
			this.setState({ viewOpen: false });
		};

		const handleClose = (event) => {
			this.setState({ open: false });
		};


	const getMarkerCounter = (projectId)  => {
			
		
			var markerCount = 1
					const authToken = localStorage.getItem('AuthToken');
						axios.defaults.headers.common = { Authorization: `${authToken}` };
						
			try {
				const resp =   axios.get(`/marker/${projectId}`)
					
				console.log("DER MARKER RET")
				console.log(resp.data)
				return 99
				}
		
			catch{
				return 1
			}
					
						/*.then((response) => {

							var helperArray= [];

								
							 response.data.forEach((vmarker) => {

									console.log("DER MARKER:"+vmarker.markerTitle)		
								 markerCount++
								})

							return 	markerCount

						})
						.catch((err) => {
						console.log("KEINE RESULTATE im Marker");
							console.log(err);
						});*/
	

			
		};






		if (this.state.uiLoading === true) {
			return (
				<main className={classes.content}>
					<div className={classes.toolbar} />
					{this.state.uiLoading && <CircularProgress size={150} className={classes.uiProgess} />}
				</main>
			);
		} else {
			
			var markerCount = 0
			
			
			return (
				<main className={classes.content}>
					<div className={classes.toolbar} />

					<IconButton
						className={classes.floatingButton}
						color="primary"
						aria-label="Add Todo"
						onClick={this.props.handler}
					>
						<AddCircleIcon style={{ fontSize: 60 }} />
					</IconButton>
					<Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
						<AppBar className={classes.appBar}>
							<Toolbar>
								<IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
									<CloseIcon />
								</IconButton>
								<Typography variant="h6" className={classes.title} >
									{this.state.buttonType === 'Edit' ? 'Edit Todo' : 'Create a new Todo'}
								</Typography>
								<Button
									autoFocus
									color="inherit"
									onClick={handleSubmit}
									className={classes.submitButton}
								>
									{this.state.buttonType === 'Edit' ? 'Save' : 'Submit'}
								</Button>
							</Toolbar>
						</AppBar>

						<form className={classes.form} noValidate>
							<Grid container spacing={2}>
								<Grid item xs={12}>
									<TextField
										variant="outlined"
										required
										fullWidth
										id="todoTitle"
										label="Todo Title"
										name="title"
										autoComplete="todoTitle"
										helperText={errors.title}
										value={this.state.title}
										error={errors.title ? true : false}
										onChange={this.handleChange}
									/>
								</Grid>
								<Grid item xs={12}>
									<TextField
										variant="outlined"
										required
										fullWidth
										id="todoDetails"
										label="Todo Details"
										name="body"
										autoComplete="todoDetails"
										multiline
										rows={25}
										rowsMax={25}
										helperText={errors.body}
										error={errors.body ? true : false}
										onChange={this.handleChange}
										value={this.state.body}
									/>
								</Grid>
							</Grid>
						</form>
					</Dialog>

					


					<Grid container spacing={2}> 
						{this.state.projects.map(project => {
				
						console.log(project)
				
						var projectImage =""
						if(project.projectImage){
						
							if((project.visualMarker == undefined) || (project.visualMarker =="") || (!project.visualMarker )){
								markerCount = "0"; 
							}
							else{
								markerCount = project.visualMarker.length
							}
							

							
							var cHash = Math.random().toString(16).substr(2, 8);	
							var tempProjectImageURL = "https://firebasestorage.googleapis.com/v0/b/moval-4c0b4.appspot.com/o/images%2F"+project.projectId+"%2F"+project.projectImage+"?alt=media&cHash="+cHash
									
							
							
				
						projectImage = <div className="image_wrapper">
												<img alt="Crop" className="projectimage" style={{ maxWidth: '300', width:'100%' }} id={"projectImage_"+project.projectId} src={tempProjectImageURL} />	
									 		</div>
						
					return (
			       	<Grid item xs={12} sm={6}>
								<Card variant="outlined">
									<CardContent>
											<Grid container spacing={2}>
													<Grid item xs={12} md={12} lg={4}>
														<div className='projectImageBlock'>
															{projectImage}
														</div>
													</Grid>

													<Grid item xs={12} md={12} lg={8}>

														<h6 className="project_date" color="textSecondary">
															{dayjs(project.createdAt).fromNow()}
														</h6>


														<h3>
															{project.projectTitle}
														</h3>
														<p className="project_subline">{project.projectSubline}</p>
															<p className="project_description">
															{project.projectDescription}
															</p>
															<p className="project_description">
															Marker: {markerCount }
															</p>
													</Grid>
											</Grid>
			
									</CardContent>
									<CardActions>
										<Button size="small" color="primary" className="view_button" onClick={() => this.props.handler({ project }, "viewProject")}>
											{' '}
											View{' '}
										</Button>
										<Button size="small"  className="edit_button" 												
											startIcon={	<FontAwesomeIcon icon={faEdit} size="xs"/>}
											onClick={() => this.props.handler({ project}, "editProject" )}>
											Edit
										</Button>
										<Button size="small" color="primary" 
										startIcon={<FontAwesomeIcon icon={faTrash} size="xs"/>}
										className="delete_button" onClick={() => this.props.handler({project}, "deleteProject" )}>
											Delete
										</Button>
									</CardActions>
								</Card>
							</Grid>
						)
		
		
		
		
		
		
		
						}
						else{
							
							return (
								<Grid item xs={12} sm={6}>
								<Card variant="outlined">
									<CardContent>
											<Grid container spacing={2}>
													
													<Grid item xs={12} sm={12}>

														<h6 className="project_date" color="textSecondary">
															{dayjs(project.createdAt).fromNow()}
														</h6>


														<h3>
															{project.projectTitle}
														</h3>
														<p className="project_subline">{project.projectSubline}</p>
															<p className="project_description">
															{project.projectDescription}
															</p>
															<p className="project_description">
															Marker: {project.markerCount}
															</p>
													</Grid>
											</Grid>
			
									</CardContent>
									<CardActions>
										<Button size="small" color="primary" className="view_button" onClick={() => this.props.handler({ project }, "viewProject")}>
											{' '}
											View{' '}
										</Button>
										<Button size="small"  className="edit_button" 												
											startIcon={	<FontAwesomeIcon icon={faEdit} size="xs"/>}
											onClick={() => this.props.handler({ project}, "editProject" )}>
											Edit
										</Button>
										<Button size="small" color="primary" 
										startIcon={<FontAwesomeIcon icon={faTrash} size="xs"/>}
										className="delete_button" onClick={() => this.props.handler({project}, "deleteProject" )}>
											Delete
										</Button>
									</CardActions>
								</Card>
							</Grid>
						)
	
						}
				
					
					})}
			
					</Grid>



					<Dialog
						onClose={handleViewClose}
						aria-labelledby="customized-dialog-title"
						open={viewOpen}
						fullWidth
						classes={{ paperFullWidth: classes.dialogeStyle }}
					>
						<DialogTitle id="customized-dialog-title" onClose={handleViewClose}>
							{this.state.title}
						</DialogTitle>
						<DialogContent dividers>
							<TextField
								fullWidth
								id="todoDetails"
								name="body"
								multiline
								readonly
								rows={1}
								rowsMax={25}
								value={this.state.body}
								InputProps={{
									disableUnderline: true
								}}
							/>
						</DialogContent>
					</Dialog>
				</main>
			);
		}
	}
}

export default withStyles(styles)(projects);